import { isDefined, isTruthy } from 'common';

interface AgenticChatActivityTimer {
  getSnapshot: () => number;
  subscribeWithoutStartingTimer: () => () => void;
  subscribe: (listener: () => void) => () => void;
}

/** Publishes cached time snapshots and stops scheduling when its last reader unsubscribes. */
export function createAgenticChatActivityTimer(options: {
  intervalMilliseconds: number;
}): AgenticChatActivityTimer {
  const { intervalMilliseconds } = options;
  const listeners = new Set<() => void>();
  let nowMilliseconds = Date.now();
  let timer: number | undefined;

  return {
    getSnapshot: () => {
      return nowMilliseconds;
    },
    subscribeWithoutStartingTimer: () => {
      return () => undefined;
    },
    subscribe: (listener: () => void) => {
      listeners.add(listener);
      if (!isDefined(timer)) {
        timer = window.setInterval(() => {
          nowMilliseconds = Date.now();
          Array.from(listeners).forEach((listener) => listener());
        }, intervalMilliseconds);
      }
      return () => {
        listeners.delete(listener);
        if (!isTruthy(listeners.size) && isDefined(timer)) {
          window.clearInterval(timer);
          timer = undefined;
        }
      };
    },
  };
}
